import React, { useEffect, useState } from 'react';
import './ParticipantScreenShareGrid.css';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useScreenShare } from '@daily-co/daily-react';

import { regularParticipantsIdState } from '../../state/participantAtom';
import Tile from '../Tile/Tile';
import { useMinScreen } from '../hooks/useMinScreen';
import { teacherScreenViewState, selectedParticipantIdState } from '../../state/viewModeAtom';

function ParticipantScreenShareGrid() {
  const [regularParticipantsId] = useRecoilState(regularParticipantsIdState);
  const { min } = useMinScreen();
  const totalParticipants = regularParticipantsId.length;
  const [pageSize, setPageSize] = useState(6);
  const [currentIndex, setCurrentIndex] = useState(0);
  const setSelectedParticipantId = useSetRecoilState(selectedParticipantIdState);
  const setViewMode = useSetRecoilState(teacherScreenViewState);

  const updatePageSize = () => {
    if (min('lg')) {
      setPageSize(6);
    } else if (min('md')) {
      setPageSize(4);
    } else {
      setPageSize(3);
    }
  };

  useEffect(() => {
    updatePageSize();
  }, [min]);

  const handleNext = () => {
    if (currentIndex + pageSize < totalParticipants) {
      setCurrentIndex((prev) => prev + pageSize);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => Math.max(0, prev - pageSize));
    }
  };

  const toggleParticipantScreen = (id) => {
    setSelectedParticipantId(id);
    setViewMode('single');
  };
  const { screens } = useScreenShare();

  const screenSharingParticipants = regularParticipantsId.filter((id) =>
    screens.some((screen) => screen.session_id === id),
  );

  return (
    <div className="grid-wrapper">
      {currentIndex > 0 && (
        <button type="button" className="arrow left" onClick={handlePrev}>
          ◀
        </button>
      )}
      {!screenSharingParticipants.length ? (
        <div className="no-screen-share">
          <p>No one is currently sharing their screen.</p>
        </div>
      ) : (
        <div className="grid-container">
          {screenSharingParticipants.slice(currentIndex, currentIndex + pageSize).map((id) => (
            <button
              type="button"
              onClick={() => toggleParticipantScreen(id)}
              className="toggle participantScreen">
              <div key={id} className="participant">
                <Tile id={id} isScreenShare />
              </div>
            </button>
          ))}
        </div>
      )}

      {currentIndex + pageSize < totalParticipants && (
        <button type="button" className="arrow right" onClick={handleNext}>
          ▶
        </button>
      )}
    </div>
  );
}

export default ParticipantScreenShareGrid;
